// Editable site content. Each export works like a WordPress block/field group.
export const SITE = {
  name: "Solitaire India",
  tagline: "People | Planet | Progress",
  positioning: ["Renewable Energy Advisory", "Solar Procurement Advisory", "Solar Solutions"],
  location: "Mumbai, Maharashtra, India",
  phone: "+91 99878 90256",
  phoneHref: "tel:+919987890256",
  email: "ankita@solitaire-india.in",
  linkedin:
    "https://www.linkedin.com/in/solitaire-india-2029a12aa?utm_source=share_via&utm_content=profile&utm_medium=member_ios",
  url: "https://solitaire-energy.preview.emergentagent.com",
};

export const NAV = [
  { id: "about", label: "About", to: "/about" },
  { id: "solutions", label: "Solar Solutions", to: "/solutions" },
  { id: "services", label: "Services", to: "/services" },
  { id: "partner", label: "Partner With Us", to: "/partner" },
  { id: "insights", label: "Insights & FAQs", to: "/insights" },
];

export const IMG = {
  hero: "/img/hero-aerial.jpg",
  rooftopDusk: "/img/hero.jpg",
  factory: "/img/factory.jpg",
  plant: "/img/plant.jpg",
  commercial: "/img/commercial.jpg",
  farm: "/img/farm.jpg",
  park: "/img/park.jpg",
  meeting: "/img/meeting.jpg",
  engineering: "/img/engineering.jpg",
};

export const MARQUEE = [
  "Solar Procurement Advisory",
  "Rooftop Solar",
  "Open Access",
  "Third-Party Open Access",
  "Captive Solar",
  "Group Captive",
  "Wind-Solar Hybrid",
  "Techno-Commercial Evaluation",
  "PPA Facilitation",
];

export const STAKEHOLDERS = [
  {
    id: "consumers",
    icon: "Factory",
    title: "C&I Consumers",
    text: "Manufacturers, commercial establishments and multi-site businesses looking to understand how solar could fit their energy mix.",
  },
  {
    id: "developers",
    icon: "Sun",
    title: "Solar Developers",
    text: "Developers and IPPs seeking well-understood, qualified commercial and industrial demand.",
  },
  {
    id: "epc",
    icon: "HardHat",
    title: "EPC Partners",
    text: "Engineering, procurement and construction companies looking for structured project opportunities.",
  },
  {
    id: "investors",
    icon: "Landmark",
    title: "Investors",
    text: "Renewable energy investors evaluating C&I and utility-scale opportunities across India.",
  },
];

export const MILESTONE = {
  value: "500",
  unit: "MWp",
  prefix: "Nearly",
  label: "in projects helped to commission",
};

export const EXPERIENCE_STAGES = [
  { n: "01", title: "Development support", text: "Understanding consumer demand, site and land suitability, and the commercial structure a project needs." },
  { n: "02", title: "Partner alignment", text: "Bringing consumers, developers and EPC partners together and keeping proposals comparable." },
  { n: "03", title: "Approvals & coordination", text: "Coordinating documentation, approvals follow-up and milestones between all parties." },
  { n: "04", title: "Through to commissioning", text: "Staying involved until the plant is commissioned and power starts flowing to the consumer." },
];

export const WHAT_WE_DO = [
  {
    id: "advisory",
    icon: "ScanSearch",
    title: "Renewable Energy Advisory",
    text: "Techno-commercial evaluation of solar models, tariffs and proposals, so every decision is an informed one.",
    to: "/services",
  },
  {
    id: "procurement-advisory",
    icon: "Network",
    title: "Solar Procurement Advisory",
    text: "Guiding C&I consumers through solar procurement: structuring requirements, approaching the market and engaging developers in an organised way.",
    to: "/services",
  },
  {
    id: "solutions",
    icon: "Sun",
    title: "Solar Solutions",
    text: "Rooftop, Open Access, Captive and Group Captive models, matched to your load profile and commercial objectives.",
    to: "/solutions",
  },
];

export const PROCESS = [
  { n: "01", title: "Understand", text: "We study your consumption pattern, sanctioned load, tariff category, site and business priorities." },
  { n: "02", title: "Evaluate", text: "We assess which solar models may be technically and commercially relevant, and what each depends on." },
  { n: "03", title: "Connect", text: "We identify and introduce suitable developers and EPC partners, and help you compare their proposals." },
  { n: "04", title: "Coordinate", text: "We support commercial discussions, approvals coordination and project milestones through to implementation." },
];

export const PILLARS = [
  { word: "People", text: "Decisions made with plant heads, finance teams and sustainability leaders, explained in plain language." },
  { word: "Planet", text: "Helping businesses take practical, well-evaluated steps towards cleaner electricity." },
  { word: "Progress", text: "Commercially sound projects that make sense for consumers, developers and partners alike." },
];

export const PARTNER_TYPES = [
  {
    id: "developers",
    icon: "Sun",
    title: "Solar Developers & IPPs",
    text: "Collaborate on C&I demand where consumption, site and commercial expectations have been understood upfront.",
  },
  {
    id: "epc",
    icon: "HardHat",
    title: "EPC Companies",
    text: "Participate in rooftop and ground-mounted opportunities with clearer scopes and structured proposal comparisons.",
  },
  {
    id: "investors",
    icon: "Landmark",
    title: "Renewable Energy Investors",
    text: "Explore opportunities linked to qualified C&I requirements and utility-scale land identification.",
  },
];

export const PARTNER_FLOW = [
  { n: "01", title: "Introduce your capabilities", text: "Share your project types, geographies, capacity range and commercial models." },
  { n: "02", title: "Alignment conversation", text: "We understand where your offering fits and how you prefer to engage." },
  { n: "03", title: "Qualified opportunities", text: "Where a consumer requirement matches, we share the relevant brief with consent." },
  { n: "04", title: "Structured engagement", text: "Proposal evaluation, commercial discussions and coordination through to execution." },
];
